import pagesIndividualAccountsEn from './accounts/default';
import pagesIndividualApprovalTasksEn from './approval-tasks/default';
import pagesIndividualApprovalsEn from './approvals/default';
import pagesIndividualCertificationsEn from './certifications/default';
import pagesIndividualClockingCorrectionEn from './clocking-correction/default';
import pagesIndividualCommonEn from './common/default';
import pagesIndividualContractEn from './contract';
import pagesIndividualDevicesEn from './devices/default';
import pagesIndividualEquipmentsEn from './equipments/default';
import pagesIndividualHomeEn from './home/default';
import pagesIndividualLookupResourcesEn from './lookup-resources/default';
import pagesIndividualMyProfileEn from './my-profile/default';
import pagesIndividualOfficialDocumentsEn from './official-documents/default';
import pagesIndividualOperationPackageEn from './operation-package/default';
import pagesIndividualOperationTasksEn from './operation-tasks/default';
import pagesIndividualPlacesEn from './places/default';
import pagesIndividualRequestTasksEn from './request-tasks/default';
import pagesIndividualRequestEn from './request/default';
import pagesIndividualSideNavEn from './side-nav/default';
import pagesIndividualTasksEn from './tasks/default';
export default {
  accounts: pagesIndividualAccountsEn,
  approvalTasks: pagesIndividualApprovalTasksEn,
  approvals: pagesIndividualApprovalsEn,
  certifications: pagesIndividualCertificationsEn,
  clockingCorrection: pagesIndividualClockingCorrectionEn,
  common: pagesIndividualCommonEn,
  contract: pagesIndividualContractEn,
  devices: pagesIndividualDevicesEn,
  equipments: pagesIndividualEquipmentsEn,
  home: pagesIndividualHomeEn,
  lookupResources: pagesIndividualLookupResourcesEn,
  myProfile: pagesIndividualMyProfileEn,
  officialDocuments: pagesIndividualOfficialDocumentsEn,
  operationPackage: pagesIndividualOperationPackageEn,
  operationTasks: pagesIndividualOperationTasksEn,
  places: pagesIndividualPlacesEn,
  request: pagesIndividualRequestEn,
  requestTasks: pagesIndividualRequestTasksEn,
  sideNav: pagesIndividualSideNavEn,
  tasks: pagesIndividualTasksEn
};